/**
 * Gas limit constants for various blockchain operations
 */
export const GAS_LIMITS = {
  /** Base gas for opening one lootbox */
  LOOTBOX_OPEN_BASE: 1_000_000,
  /** Additional gas per item in lootbox */
  LOOTBOX_OPEN_PER_ITEM: 50_000,
  /** Maximum lootboxes to open in a single batch */
  MAX_LOOTBOX_OPEN_BATCH: 20,
} as const;
